import Helpers from '@Apis/helpers';
import { entityNameEnum } from '@Apis/constants';

export const addAlpha = (color, opacity) => {
  // coerce values so ti is between 0 and 1.
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
};

export function handleFileChange({ fileListData, selectedSO,  updateAttachment, getAttachmentById, dispatch }) {

  const fileList = fileListData?.fileList?.map((item) => ({
    ...item,
    url: item?.response?.response?.location || item?.url,
  }));

  const attachments = fileList?.map((attachment) => ({
    url: attachment?.response?.response?.location || attachment?.url,
    type: attachment.type,
    name: attachment.name,
    uid: attachment.uid,
  }));

  if (fileListData?.file.status === 'done') {
    const payload = {
      entity_id: selectedSO?.order_id,
      entity_name: 'sales_order',
      attachments,
    };
    updateAttachment(payload, () => {
      getAttachmentById(selectedSO?.order_id, 'sales_order', () => {
        dispatch({
          type: 'SET_IS_GET_ATTACHMENT',
          payload: true,
        });
      });
    });
  }
  if (fileListData?.file.status === 'removed') {
    const payload = {
      entity_id: selectedSO?.order_id,
      entity_name: 'sales_order',
      attachments,
    };
    updateAttachment(payload, () => {
      getAttachmentById(selectedSO?.order_id, 'sales_order', () => {
        dispatch({
          type: 'SET_IS_GET_ATTACHMENT',
          payload: true,
        });
      });
    });
  }

  dispatch({
    type: 'SET_FILE_LIST',
    payload: attachments?.length > 0 ? attachments : [],
  });
}

export function tenantIdProductMapping(productSkuTenantIdMapping, products) {
  const uniqueProductSkuIds = [
    ...new Set(Object.keys(productSkuTenantIdMapping || {})),
  ];

  const tenantIdProductSkuIdsMap = new Map();

  for (const productSku in productSkuTenantIdMapping) {
    const entries = productSkuTenantIdMapping[productSku];
    for (const entry of entries) {
      if (!tenantIdProductSkuIdsMap.has(entry?.tenant_id)) {
        tenantIdProductSkuIdsMap.set(entry?.tenant_id, []);
      }
      tenantIdProductSkuIdsMap.get(entry?.tenant_id).push(productSku);
    }
  }

  const tenantIdProductMapping = {};

  for (const [tenantId, skuIds] of tenantIdProductSkuIdsMap.entries()) {
    const obj = {};
    if (skuIds?.length) {
      const availableProducts = [];
      const unavailableProducts = [];

      for (let i = 0; i < skuIds?.length; i++) {
        availableProducts.push(
          products?.find(
            (product) => product?.product_sku_info?.product_sku_id == skuIds[i],
          )?.product_sku_info,
        );
      }

      // eslint-disable-next-line unicorn/no-for-loop
      for (let i = 0; i < uniqueProductSkuIds.length; i++) {
        if (!skuIds.includes(uniqueProductSkuIds[i])) {
          unavailableProducts.push(
            products?.find(
              (product) => product?.product_sku_info?.product_sku_id
                == uniqueProductSkuIds[i],
            )?.product_sku_info,
          );
        }
      }
      obj.availableProducts = availableProducts;
      obj.unavailableProducts = unavailableProducts;
    }
    tenantIdProductMapping[tenantId] = obj;
  }
  return tenantIdProductMapping;
}

export const HideAdhocApprovals = (selectedSO) => {
  if (selectedSO?.workflow_steps) {
    const steps = Object.values(selectedSO?.workflow_steps)?.filter(
      (step) => step !== null,
    );
    const pendingSteps = steps?.filter(
      (step) => step?.status === 'PENDING',
    );
    return steps.length < 10 && pendingSteps.length === steps.length;
  }
  return false;
};

export const getLinkedDocumentInfo = ({
  selectedSO,
  user,
  isDataMaskingPolicyEnable,
  isHideSellingPrice,
}) => {
  let linkedDocumentsInfo = [];

  if (selectedSO?.ps_linked_sales_orders?.length > 0) {
    linkedDocumentsInfo.push({
      entityName: entityNameEnum.SALES_ORDER,
      title: 'SALES ORDERS',
      entityNumberPrefix: '',
      documentData: selectedSO?.ps_linked_sales_orders?.map(item => ({
        documentId: item?.order_id,
        documentNumber: item?.sales_order_number,
        documentStatus: item?.status,
        documentTotal: item?.order_grand_total,
      })),
      isRedirect: true,
      redirectPath: '/sales/sales-order/view/',
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user) && selectedSO?.ps_linked_sales_orders?.length > 0,
      showEntityTotal: true,
      hidePrice: isDataMaskingPolicyEnable && isHideSellingPrice,
      popOverMessage: "You don't have access to view amount",
    });
  }

  if (selectedSO?.invoices?.length > 0) {
    linkedDocumentsInfo.push({
      entityName: entityNameEnum.INVOICE,
      title: 'INVOICES',
      entityNumberPrefix: '',
      documentData: selectedSO?.invoices?.map(item => ({
        documentId: item?.invoice_id,
        documentNumber: item?.invoice_number,
        documentStatus: item?.status,
        documentTotal: item?.invoice_grand_total,
      })),
      isRedirect: true,
      redirectPath: '/sales/invoice/view/',
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ, user) && selectedSO?.invoices?.length > 0,
      showEntityTotal: false,
      hidePrice: isDataMaskingPolicyEnable && isHideSellingPrice,
      popOverMessage: "You don't have access to view amount",
    });
  }

  return linkedDocumentsInfo;
};